import {Expose} from "class-transformer";
import {CommandPayload} from "./command-payload";

/**
 * Payload of `SaveTenantSettingsCommand` (feature plans 0068, 0069): the tenant's start page as a route
 * name from `START_PAGE_GROUPS`, and the ShortId of a concrete Linkboard or knowledge object under it;
 * `''` removes either. The backend handler requires exactly these two keys, so both are constructor
 * arguments without a default — no caller can forget the target.
 */
export class TenantSettingsContent extends CommandPayload {

    @Expose()
    public startPage: string;

    @Expose()
    public startPageTarget: string;

    public constructor(startPage: string, startPageTarget: string) {
        super();
        this.startPage = startPage;
        this.startPageTarget = startPageTarget;
    }
}
